import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingChatButton from "./WhatsAppButton";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#0D0F12] text-white flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
      <FloatingChatButton />
    </div>
  );
}
